var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-modal-frame",
    {
      attrs: {
        title: "Why do you need my email address?",
        "is-showing": _vm.isShowing,
      },
      on: {
        "close-modal": function ($event) {
          return _vm.$emit("close-modal")
        },
      },
    },
    [
      _vm.hasArrivedFromFigma
        ? _c("p", { staticClass: "margin-bottom-lg" }, [
            _vm._v(
              "\n    We create unique Tokens for each account that allow Figma to use Font Awesome icons. And, for Pro users, your Tokens let you use Pro icons and your custom\n    icons in Figma too!\n  "
            ),
          ])
        : _c("p", { staticClass: "margin-bottom-lg" }, [
            _vm._v(
              "\n    We create Kits for you to manage the icons you use in your projects. To do this, we need to create a Font Awesome account so we know which Kits are yours and so you can come back and manage them.\n  "
            ),
          ]),
      _vm._v(" "),
      _c("p", { staticClass: "margin-bottom-lg" }, [
        _vm._v("\n    A Font Awesome account is free to have,\n    "),
        _c("strong", [
          _vm._v("but a valid email account is required to set up an account."),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "p",
        [
          _vm._v("\n    You can read more about\n    "),
          _c("site-link", { attrs: { to: { name: "privacy" } } }, [
            _vm._v("how we use your email address"),
          ]),
          _vm._v("\n    and what\n    "),
          _c("site-link", { attrs: { to: { name: "tos" } } }, [
            _vm._v("terms of service"),
          ]),
          _vm._v("\n    come with having an account.\n  "),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }